export default "__VITE_ASSET__e1786632__"